/**
 * CTA — the closing gradient band. Primary "Se connecter" + secondary
 * "Créer un compte", both routing through the shared auth entry points.
 */

import { FINAL_CTA } from '@/routes/landing/landing-data';
import { useLandingCta } from './shared';

export function CTA() {
  const { signin, signup } = useLandingCta();

  return (
    <section className="mx-auto w-full max-w-7xl px-4 pb-16 sm:px-6 sm:pb-20 lg:px-8 lg:pb-24">
      <div className="relative isolate overflow-hidden rounded-token-xl bg-gradient-to-br from-indigo-600 via-violet-600 to-fuchsia-600 px-6 py-14 text-center shadow-elevation-3 sm:px-12 sm:py-16">
        <div aria-hidden="true" className="absolute inset-0 -z-10 bg-[radial-gradient(120%_120%_at_50%_0%,rgb(255_255_255/0.18),transparent_60%)]" />
        <div aria-hidden="true" className="absolute -bottom-24 -right-16 -z-10 h-72 w-72 rounded-full bg-white/10 blur-3xl" />

        <h2 className="mx-auto max-w-2xl text-balance text-3xl font-extrabold tracking-tight text-white sm:text-4xl">
          {FINAL_CTA.title}
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-pretty text-lg leading-relaxed text-white/90">
          {FINAL_CTA.subtitle}
        </p>

        <div className="mt-8 flex flex-col justify-center gap-3 sm:flex-row">
          <button
            type="button"
            onClick={() => signin()}
            className="inline-flex items-center justify-center gap-2 rounded-token bg-white px-6 py-3 text-base font-semibold text-indigo-700 shadow-elevation-2 transition hover:bg-white/90 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-white/50 motion-reduce:transition-none"
          >
            {FINAL_CTA.primaryCta}
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" className="h-5 w-5">
              <path d="M4.5 12h15m0 0-6.75-6.75M19.5 12l-6.75 6.75" />
            </svg>
          </button>
          <button
            type="button"
            onClick={() => signup()}
            className="inline-flex items-center justify-center gap-2 rounded-token border border-white/40 bg-white/10 px-6 py-3 text-base font-semibold text-white backdrop-blur transition hover:bg-white/20 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-white/50 motion-reduce:transition-none"
          >
            {FINAL_CTA.secondaryCta}
          </button>
        </div>
      </div>
    </section>
  );
}
